// import {useBootstrapData} from '../core/bootstrap-data/bootstrap-data-context';

export function useSelectedLocale() {
  // const {
  //   data: {i18n},
  // } = useBootstrapData();

  // console.log('first', i18n?.lines)

  return {
    locale: 'en_US',
    localeCode: 'en',
    lines: undefined,
  };
  // return {
  //   locale: i18n,
  //   localeCode: i18n?.language || 'en',
  //   lines: i18n?.lines,
  // };
}
